module.exports = __webpack_public_path__ + "de732940ba7cf9c739380ad193255e54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/service_04.jpg
// module id = KZp7
// module chunks = 0